import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-expansion-fieldset',
    templateUrl: './expansion-fieldset.component.html',
    styleUrls: ['./expansion-fieldset.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExpansionFieldsetComponent implements OnInit {
    @Input() label: string;

    @Input() visible = false;

    constructor() {}

    ngOnInit() {}

    changeVisible() {
        this.visible = !this.visible;
    }
}
